<template>
  <div class="prize_user_row">
    <div class="user_img_bg">
      <!-- Clickable avatar for authenticated users -->
      <div
        class="avatar-link"
        @click="handleProfileClick"
        style="cursor: pointer;"
      >
        <AvatarImage
          :src="winner.userDTO?.avatar || winner.avatar"
          :alt="winnerUsername"
          @error="handleImageError"
        />
      </div>
    </div>

    <div class="col_mobile">
      <div class="user_info">
        <!-- Clickable username for authenticated users -->
        <div
          class="name-link"
          @click="handleProfileClick"
          style="cursor: pointer;"
        >
          <p class="name clickable">{{ winnerUsername }}</p>
        </div>

        <p class="cash">{{ winnerPrizeDescription }}</p>
      </div>

      <div class="date_box">
        <p class="date_txt">{{ $_translations.value.page_winners_auth_user_item_date }}</p>
        <p class="date">{{ formatShortDate(winnerDate) }}</p>
      </div>
    </div>
  </div>

  <!-- User Profile Modal -->
  <UserProfileDetailsModal
    v-if="isVisible"
    :user-profile="userProfileData"
    @close="handleModalClose"
  />
</template>

<script setup>
import { computed } from 'vue';
import AvatarImage from '@/components/image/AvatarImage.vue';
import UserProfileDetailsModal from '../modal/UserProfileDetailsModal.vue';
import useModalHook from '@/hooks/useModal.js';

const props = defineProps({
  winner: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});
const [isVisible, openModal, closeModal] = useModalHook();

// Computed properties for winner data
const winnerUsername = computed(() => {
  return props.winner.username ||
    props.winner.userDTO?.username ||
    'Anonymous';
});

const winnerPrizeDescription = computed(() => {
  return props.winner.prizeDTO?.headline ||
    props.winner.rewardDescription ||
    'Prize';
});

const winnerDate = computed(() => {
  return props.winner.winDate ||
    props.winner.rewardDate ||
    props.winner.localDateTime ||
    '';
});

// Prepare user profile data for modal
const userProfileData = computed(() => {
  return {
    id: props.winner.id || props.winner.userDTO?.id,
    name: winnerUsername.value,
    avatar: props.winner.userDTO?.avatar || props.winner.avatar,
    collectedPoints: props.winner.userDTO?.collectedPoints || props.winner.collectedPoints || 0,
    level: props.winner.userDTO?.level || props.winner.level || 1,
    gamesPlayed: props.winner.userDTO?.gamesPlayed || props.winner.gamesPlayed || 0,
    correctAnswers: props.winner.userDTO?.correctAnswers || props.winner.correctAnswers || 0,
    achievements: props.winner.userDTO?.achievements || props.winner.achievements || 0,
    msisdn: props.winner.userDTO?.msisdn || props.winner.msisdn || '',
  };
});

// Format date for display (short format DD/MM/YYYY)
const formatShortDate = (dateString) => {
  if (!dateString) return 'DD/MM/YYYY';

  try {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${ day }/${ month }/${ year }`;
  } catch {
    return 'DD/MM/YYYY';
  }
};

// Handle avatar image errors
const handleImageError = (event) => {
  event.target.src = '/static/images/avatars/avatar_01.svg';
};

// Handle profile click - show modal
const handleProfileClick = (event) => {
  event.preventDefault();
  event.stopPropagation();

  openModal();
};

// Handle modal close
const handleModalClose = () => {
  closeModal();
};
</script>
